import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAgents: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAgents"><Circle cx="6" cy="5" r="2.5" stroke="currentColor"/><Circle cx="18" cy="19" r="2.5" stroke="currentColor"/><Path d="M8.75 12L12 8.75L15.25 12L12 15.25L8.75 12Z" stroke="currentColor"/><Path d="M8.5 5H17C18.933 5 20.5 6.567 20.5 8.5C20.5 10.433 18.933 12 17 12H15" stroke="currentColor"/><Path d="M9 12H7C5.067 12 3.5 13.567 3.5 15.5C3.5 17.433 5.067 19 7 19H15.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconAgents;
